<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="usuarios.content"
      class="mt-5"
      :loading="loading"
      :server-items-length="usuarios.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma cotação encontrada"
      loading-text="Carregando cotações..."
      :options="optionsList"
    >
      <template v-slot:item.enabled="{ item }">
          <px-boolean-sim-nao :value="item.enabled"/>
      </template>
      <template v-slot:item.options="{ item }">
        <px-usuario-detalhes :usuario="item" @update="emitUpdate">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" v-if="hasRoleAdmin">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </px-usuario-detalhes>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UsuarioDetalhes from './UsuarioDetalhes.vue';

export default {
  props: {
    usuarios: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Nome',
          value: 'nome',
          sortable: true,
        },
        {
          text: 'E-mail',
          value: 'email',
          sortable: true,
        },
        {
          text: 'Ativo',
          value: 'enabled',
          sortable: true,
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleAdmin']),
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    emitUpdate() {
      this.$emit('update');
    },
  },
  components: {
    pxUsuarioDetalhes: UsuarioDetalhes,
  },
};
</script>
